var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.82812 8.39551V18.3955",
    stroke: "#333333",
    strokeWidth: 1.99943,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4935 4.96283L11.6602 8.39616H16.5185C16.7772 8.39616 17.0324 8.4564 17.2638 8.57211C17.4953 8.68783 17.6966 8.85583 17.8518 9.06283C18.0071 9.26982 18.112 9.51012 18.1583 9.76468C18.2046 10.0193 18.1909 10.2811 18.1185 10.5295L16.1768 17.1962C16.0758 17.5424 15.8653 17.8465 15.5768 18.0628C15.2883 18.2792 14.9374 18.3962 14.5768 18.3962H3.32682C2.8848 18.3962 2.46087 18.2206 2.14831 17.908C1.83575 17.5954 1.66016 17.1715 1.66016 16.7295V10.0628C1.66016 9.6208 1.83575 9.19688 2.14831 8.88431C2.46087 8.57175 2.8848 8.39616 3.32682 8.39616H5.62682C5.93689 8.39599 6.24077 8.30934 6.50429 8.14593C6.7678 7.98252 6.98051 7.74884 7.11849 7.47116L9.99349 1.72949C10.3865 1.73436 10.7733 1.82797 11.125 2.00332C11.4767 2.17868 11.7843 2.43125 12.0247 2.74216C12.2651 3.05307 12.4321 3.41429 12.5133 3.79883C12.5945 4.18336 12.5877 4.58127 12.4935 4.96283Z",
    stroke: "#333333",
    strokeWidth: 1.99943,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbupIcon);
export default __webpack_public_path__ + "static/media/thumbup-icon.d21c1d20ab2a63fe722a4d6fe436590c.svg";
export { ForwardRef as ReactComponent };